import zIndex from "@mui/material/styles/zIndex";

export const AccountStyle = (theme) => ({
  container: {
    width: "80%",
    margin: "auto",
    display: "grid",
    gridTemplateColumns: "1fr 350px",
    gap: "24px",
    alignItems: "start",
    paddingTop: "24px",
    paddingBottom: "40px",

    "@media (max-width: 800px)": {
      gridTemplateColumns: "100%",
      width: "90%",
      gap: "16px",
      paddingTop: "16px",
    },
  },

  topLeftContainer: {
    width: "100%",
    maxWidth: "100%",
    overflow: "hidden",

    "@media (max-width: 800px)": {
      width: "100%",
    },
  },

  topRightContainer: {
    width: "100%",
    position: "sticky",
    top: "80px",
    marginBottom: "40px",

    "@media (max-width: 800px)": {
      width: "100%",
      height: "100%",
      marginTop: "30px",
      marginBottom: "40px",
      position: "relative",
      top: "auto",
    },
  },

  displayPictureSection: {
    backgroundColor: theme.palette.mode === "dark" ? "#222428" : "#2a3478",
    height: "200px",
    position: "relative",
    zIndex: 2,
  },

  coverPictureSection: {
    height: "200px",
    width: "100%",
    position: "relative",
    zIndex: 1,
  },

  coverPictureContent: {
    height: "200px",
    width: "100%",
    backgroundSize: "cover",
    objectFit: "cover",
    transition: "transform 0.3s ease",
    "&:hover": {
      transform: "scale(1.02)",
    },
  },

  avatarPictureSection2: {
    position: "relative",
    bottom: "70px",
    marginLeft: "20px",
    zIndex: 3,
  },

  avatarPictureSection1: {
    position: "relative",
    top: "-75px",
    marginLeft: "20px",
    zIndex: 3,
  },

  avatarPictureContainer: {
    position: "relative",
    display: "inline-block",
    zIndex: 3,
  },

  avatarGradientRing: {
    position: "relative",
    width: "156px",
    height: "156px",
    borderRadius: "50%",
    padding: "3px",
    background: theme.palette.mode === "dark"
      ? "linear-gradient(135deg, #ff6f00, #d44402, #aa00ff, #00d4ff, #ff6f00)"
      : "linear-gradient(135deg, #d44402, #1976d2, #7b1fa2, #00d4ff, #d44402)",
    backgroundSize: "400% 400%",
    animation: "$gradientRotate 6s ease infinite",
    boxShadow: theme.palette.mode === "dark"
      ? "0 0 30px rgba(212, 68, 2, 0.3), 0 0 60px rgba(170, 0, 255, 0.15)"
      : "0 0 30px rgba(212, 68, 2, 0.2), 0 0 60px rgba(21, 101, 192, 0.1)",
    "&::before": {
      content: '""',
      position: "absolute",
      inset: "3px",
      borderRadius: "50%",
      background: theme.palette.mode === "dark" ? "#222428" : "#2a3478",
    },
  },

  "@keyframes gradientRotate": {
    "0%": { backgroundPosition: "0% 50%" },
    "50%": { backgroundPosition: "100% 50%" },
    "100%": { backgroundPosition: "0% 50%" },
  },

  avatarInnerContainer: {
    position: "relative",
    zIndex: 1,
  },

  avatarPictureContent: {
    borderRadius: "50%",
    width: "150px",
    height: "150px",
    backgroundColor: "#9aa193",
    objectFit: "cover",
    transition: "all 0.3s cubic-bezier(0.4, 0, 0.2, 1)",
    display: "block",
    "&:hover": {
      transform: "scale(1.05)",
      boxShadow: theme.palette.mode === "dark"
        ? "0 8px 24px rgba(212, 68, 1, 0.4)"
        : "0 8px 24px rgba(0, 0, 0, 0.3)",
    },
  },

  dummyAvatarPictureContent: {
    borderRadius: "50%",
    width: "150px",
    border: "3px solid black",
    height: "150px",
    backgroundColor: "#16181C",
  },

  editProfileButtonSection: {
    marginTop: "95px",
    float: "right",
    textAlign: "right",
    padding: "0px 20px",
    display: "flex",
    justifyContent: "flex-end",
    gap: "10px",
    zIndex: 3,
    position: "relative",
  },

  editProfileButton: {
    outline: "none",
    border: theme.palette.mode === "dark"
      ? "2px solid rgba(255, 255, 255, 0.2)"
      : "2px solid rgba(0, 0, 0, 0.15)",
    padding: "10px 20px",
    backgroundColor: theme.palette.mode === "dark"
      ? "rgba(255, 255, 255, 0.05)"
      : "rgba(255, 255, 255, 0.9)",
    borderRadius: "12px",
    color: theme.palette.mode === "dark" ? "#f9fafb" : "#2a3478",
    cursor: "pointer",
    marginLeft: "10px",
    fontWeight: 600,
    fontSize: "14px",
    transition: "all 0.3s cubic-bezier(0.4, 0, 0.2, 1)",
    backdropFilter: "blur(10px)",
    "&:hover": {
      backgroundColor: theme.palette.mode === "dark"
        ? "rgba(212, 68, 1, 0.15)"
        : "#d44401",
      color: "#ffffff",
      border: theme.palette.mode === "dark"
        ? "2px solid rgba(212, 68, 1, 0.5)"
        : "2px solid #d44401",
      transform: "translateY(-2px)",
      boxShadow: theme.palette.mode === "dark"
        ? "0 6px 20px rgba(212, 68, 1, 0.4)"
        : "0 6px 20px rgba(212, 68, 1, 0.3)",
    },
    "&:active": {
      transform: "translateY(0)",
    },
  },

  displayPictureAfterSection: {
    marginTop: "100px",
    width: "100%",
    position: "relative",
    zIndex: 1,
  },

  bioContainer: {
    padding: "24px",
    borderRadius: "16px",
    backgroundColor: theme.palette.mode === "dark" ? "#1a1a1f" : "#ffffff",
    color: theme.palette.mode === "dark" ? "#f9fafb" : "#111827",
    animation: "$fadeIn 0.5s ease-in-out",
    border: `1px solid ${theme.palette.mode === "dark" ? "rgba(255,255,255,0.1)" : "rgba(212,68,1,0.1)"}`,
    boxShadow: theme.palette.mode === "dark"
      ? "0 4px 20px rgba(0, 0, 0, 0.3)"
      : "0 4px 20px rgba(212, 68, 1, 0.08)",
    transition: "all 0.3s ease",
    position: "relative",
    overflow: "hidden",
    width: "100%",
    boxSizing: "border-box",
    "&::before": {
      content: '""',
      position: "absolute",
      top: 0,
      left: 0,
      right: 0,
      height: "3px",
      background: theme.palette.mode === "dark"
        ? "linear-gradient(90deg, #d44401, #2a3478)"
        : "linear-gradient(90deg, #d44401, #2a3478)",
      opacity: 0.6,
    },
  },

  "@keyframes fadeIn": {
    from: {
      opacity: 0,
      transform: "translateY(20px)",
    },
    to: {
      opacity: 1,
      transform: "translateY(0)",
    },
  },

  usernameSection: {
    fontSize: "20px",
    fontWeight: "800",
    fontFamily:
      "apple-system, system-ui, Segoe UI, Roboto, Helvetica, Arial, sans-serif",
    lineHeight: "24px",
  },

  usernameContent: {
    // fontSize: "20px",
  },

  usernameIdentifier: {
    color: "gray",
  },

  innerBioContainer1: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "flex-start",
    gap: "16px",
    color: "gray",
    margin: "0px",
    fontFamily: "Times New Roman",
    fontSize: "15px",
    flexWrap: "wrap",
    "@media (max-width: 600px)": {
      flexDirection: "column",
      alignItems: "stretch",
      gap: "12px",
    },
  },

  bioDate: {},

  coinBalanceSection: {
    textAlign: "right",
    color: "#C7C7C7",
  },

  fundCoinButtonSection: {
    textAlign: "right",
    float: "right",
  },

  fundCoinButton: {
    outline: "none",
    border: "1px solid whitesmoke",
    padding: "10px",
    backgroundColor: "transparent",
    borderRadius: "10px",
    color: "white",
    cursor: "pointer",
  },

  profileErrorScreen: {
    fontFamily:
      "apple-system, system-ui, Segoe UI, Roboto, Helvetica, Arial, sans-serif",
    textAlign: "center",
    marginTop: "30px",
    padding: "40px 20px",
    backgroundColor: "#1e1e1e",
    borderRadius: "8px",
    boxShadow: "0 2px 10px rgba(0, 0, 0, 0.2)",
  },

  profileErrorScreenSmallNotice: {
    color: "gray",
    marginTop: "10px",
    marginBottom: "20px",
  },

  customTabPanelStyles: {
    padding: "0px",
    width: "500px",
    maxWidth: "500px",

    "@media (max-width: 420px)": {
      width: "auto",
      maxWidth: "auto",
    },
  },

  customFormContainerStyles: {
    maxHeight: "300px",
  },

  buttonStyles: {
    width: "100%",
    margin: "10px 0px",
  },

  // Improved user activity section styling
  meUserSection: {
    margin: "40px 0px 0px",
  },

  meUserActivitySection: {
    margin: "0px 0px 30px",
    maxHeight: "400px",
    overflow: "auto",
    backgroundColor: "transparent",
    borderRadius: "8px",
    border: "1px solid #333",
    boxShadow: "0 2px 4px rgba(0, 0, 0, 0.2)",

    "@media (max-width: 800px)": {
      margin: "0px",
    },
  },

  userActivityInfoSection: {
    display: "grid",
    gridTemplateColumns: "70% 30%",
  },

  // Activity specific styles
  activityAccordion: {
    backgroundColor: "#222428",
    boxShadow: "none",
    borderBottom: "1px solid #333",
  },

  activityAccordionSummary: {
    minHeight: "48px",
  },

  activityAccordionDetails: {
    padding: "8px 16px 16px 48px",
    backgroundColor: "#1e1e1e",
    borderTop: "1px solid #2a2a2a",
  },

  activityIcon: {
    marginRight: "12px",
    display: "flex",
    alignItems: "center",
    flexShrink: 0,
  },

  // Empty states and loading indicators
  emptyStateContent: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    padding: "40px 20px",
    backgroundColor: "#1e1e1e",
    color: "#888",
    textAlign: "center",
  },

  loadingContainer: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    padding: "40px 0px",
    backgroundColor: "#1e1e1e",
  },

  endMessage: {
    textAlign: "center",
    padding: "12px",
    color: "#777",
    fontSize: "13px",
    backgroundColor: "#1e1e1e",
    borderTop: "1px solid #333",
  },

  // Membership badge styles
  premiumBadge: {
    position: "absolute",
    bottom: "5px",
    right: "25px",
    width: "20px",
    height: "20px",
    borderRadius: "50%",
    backgroundColor: "#d44402",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    border: "2px solid #000",
    zIndex: "10",
  },

  premiumText: {
    color: "#d44402",
    marginLeft: "10px",
    fontWeight: "500",
  },

  upgradeButton: {
    backgroundColor: "#d44401",
    borderColor: "#d44401",
    color: "white",
    fontWeight: 600,
    transition: "all 0.3s cubic-bezier(0.4, 0, 0.2, 1)",
    "&:hover": {
      backgroundColor: "#b83a01",
      boxShadow: "0 6px 20px rgba(212, 68, 1, 0.4)",
      transform: "translateY(-2px)",
    },
  },

  premiumButton: {
    backgroundColor: theme.palette.mode === "dark" ? "#1a1a1f" : "rgba(212, 68, 1, 0.1)",
    borderColor: "#d44401",
    color: "#d44401",
    fontWeight: 600,
    transition: "all 0.3s cubic-bezier(0.4, 0, 0.2, 1)",
    "&:hover": {
      backgroundColor: "rgba(212, 68, 1, 0.15)",
      boxShadow: "0 6px 20px rgba(212, 68, 1, 0.3)",
      transform: "translateY(-2px)",
    },
  },

  standardBadge: {
    position: "absolute",
    bottom: "5px",
    right: "25px",
    width: "20px",
    height: "20px",
    borderRadius: "50%",
    backgroundColor: "#1976d2",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    border: "2px solid #000",
    zIndex: "10",
  },

  eliteBadge: {
    position: "absolute",
    bottom: "5px",
    right: "25px",
    width: "20px",
    height: "20px",
    borderRadius: "50%",
    backgroundColor: "#aa00ff",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    border: "2px solid #000",
    zIndex: "10",
  },

  standardButton: {
    backgroundColor: theme.palette.mode === "dark" ? "#1a1a1f" : "rgba(25, 118, 210, 0.1)",
    borderColor: "#1976d2",
    color: "#1976d2",
    fontWeight: 600,
    transition: "all 0.3s cubic-bezier(0.4, 0, 0.2, 1)",
    "&:hover": {
      backgroundColor: "rgba(25, 118, 210, 0.15)",
      boxShadow: "0 6px 20px rgba(25, 118, 210, 0.3)",
      transform: "translateY(-2px)",
    },
  },

  eliteButton: {
    backgroundColor: theme.palette.mode === "dark" ? "#1a1a1f" : "rgba(170, 0, 255, 0.1)",
    borderColor: "#aa00ff",
    color: "#aa00ff",
    fontWeight: 600,
    transition: "all 0.3s cubic-bezier(0.4, 0, 0.2, 1)",
    "&:hover": {
      backgroundColor: "rgba(170, 0, 255, 0.15)",
      boxShadow: "0 6px 20px rgba(170, 0, 255, 0.3)",
      transform: "translateY(-2px)",
    },
  },

  // Membership modal styles
  membershipCard: {
    border: "1px solid rgba(255, 255, 255, 0.1)",
    borderRadius: "12px",
    padding: "20px",
    transition: "all 0.3s ease",
    cursor: "pointer",
    position: "relative",
    height: "100%",
  },

  membershipCardSelected: {
    boxShadow: "0 0 0 2px #1976d2",
    backgroundColor: "rgba(25, 118, 210, 0.04)",
  },

  membershipCardPremiumSelected: {
    boxShadow: "0 0 0 2px #d44402",
    backgroundColor: "rgba(212, 68, 2, 0.04)",
  },

  membershipCardEliteSelected: {
    boxShadow: "0 0 0 2px #aa00ff",
    backgroundColor: "rgba(170, 0, 255, 0.04)",
  },

  popularBadge: {
    position: "absolute",
    top: "-12px",
    left: "50%",
    transform: "translateX(-50%)",
    backgroundColor: "#d44402",
    color: "white",
    padding: "4px 12px",
    borderRadius: "4px",
    fontSize: "0.75rem",
    fontWeight: "600",
  },

  membershipPriceTag: {
    fontSize: "24px",
    fontWeight: "700",
    marginBottom: "16px",
    display: "flex",
    alignItems: "baseline",
  },

  membershipPriceMonth: {
    fontSize: "14px",
    fontWeight: "400",
    marginLeft: "4px",
    opacity: "0.7",
  },

  membershipFeatureList: {
    listStyle: "none",
    padding: "0",
    margin: "16px 0",
  },

  membershipFeatureItem: {
    display: "flex",
    alignItems: "center",
    marginBottom: "8px",
    fontSize: "14px",
  },

  membershipFeatureIcon: {
    marginRight: "8px",
    color: "#1976d2",
  },

  membershipFeatureIconPremium: {
    marginRight: "8px",
    color: "#d44402",
  },

  membershipFeatureIconElite: {
    marginRight: "8px",
    color: "#aa00ff",
  },

  membershipActionButton: {
    width: "100%",
    padding: "10px",
    borderRadius: "8px",
    border: "none",
    fontWeight: "600",
    cursor: "pointer",
    marginTop: "16px",
    transition: "all 0.2s ease",
  },

  standardActionButton: {
    backgroundColor: "#1976d2",
    color: "white",
    "&:hover": {
      backgroundColor: "#1565c0",
    },
  },

  premiumActionButton: {
    backgroundColor: "#d44402",
    color: "white",
    "&:hover": {
      backgroundColor: "#b53a00",
    },
  },

  eliteActionButton: {
    backgroundColor: "#aa00ff",
    color: "white",
    "&:hover": {
      backgroundColor: "#9000d6",
    },
  },

  upgradeWithCardButton: {
    width: "100%",
    padding: "14px",
    borderRadius: "8px",
    backgroundColor: "#d44402",
    color: "white",
    fontWeight: "600",
    border: "none",
    cursor: "pointer",
    fontSize: "16px",
    transition: "all 0.3s ease",
    marginTop: "24px",
    boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)",
    "&:hover": {
      backgroundColor: "#c03e02",
      boxShadow: "0 6px 8px rgba(0, 0, 0, 0.15)",
    },
    "&:disabled": {
      backgroundColor: "#555",
      cursor: "not-allowed",
      opacity: 0.7,
    },
  },

  // Styles for daily bonus and ad status widgets
  widgetContainer: {
    backgroundColor: "#222428",
    borderRadius: "10px",
    padding: "15px",
    marginBottom: "15px",
    border: "1px solid rgba(255, 255, 255, 0.1)",
  },

  widgetTitle: {
    fontSize: "16px",
    fontWeight: "600",
    marginBottom: "10px",
    display: "flex",
    alignItems: "center",
  },

  widgetTitleIcon: {
    marginRight: "8px",
  },

  bonusReadyButton: {
    backgroundColor: "#4caf50",
    color: "white",
    border: "none",
    borderRadius: "8px",
    padding: "8px 16px",
    fontWeight: "600",
    cursor: "pointer",
    transition: "all 0.2s ease",
    "&:hover": {
      backgroundColor: "#43a047",
    },
  },

  bonusClaimedButton: {
    backgroundColor: "#555",
    color: "white",
    border: "none",
    borderRadius: "8px",
    padding: "8px 16px",
    fontWeight: "600",
    cursor: "not-allowed",
    opacity: 0.7,
  },

  bonusTimer: {
    fontSize: "14px",
    color: "#bbb",
    marginTop: "8px",
  },

  adStatusInfo: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    marginTop: "8px",
  },

  adActionButtons: {
    display: "flex",
    gap: "8px",
    marginTop: "12px",
  },

  watchAdButton: {
    backgroundColor: "#1976d2",
    color: "white",
    border: "none",
    borderRadius: "8px",
    padding: "8px 16px",
    fontWeight: "600",
    cursor: "pointer",
    transition: "all 0.2s ease",
    "&:hover": {
      backgroundColor: "#1565c0",
    },
  },

  upgradeAdButton: {
    backgroundColor: "#d44402",
    color: "white",
    border: "none",
    borderRadius: "8px",
    padding: "8px 16px",
    fontWeight: "600",
    cursor: "pointer",
    transition: "all 0.2s ease",
    "&:hover": {
      backgroundColor: "#b53a00",
    },
  },
});
